import React from "react";
import { Building, ShoppingCart, Briefcase, Rocket, Users, Globe2, MonitorCheck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const clientGroups = [{
  icon: Building,
  title: "UK SMEs",
  challenge: "Growing service companies and regional businesses looking for an SEO consultant for small businesses to compete effectively against larger competitors and turn organic traffic into reliable customer enquiries."
}, {
  icon: ShoppingCart,
  title: "Ecommerce businesses",
  challenge: "Online retailers needing cleaner category architecture, resolved indexing snags and better commercial visibility across high-converting product ranges."
}, {
  icon: Briefcase,
  title: "B2B companies",
  challenge: "Specialist providers and technology firms wanting to reach professional buyers with high-intent search terms tailored to extended sales cycles."
}, {
  icon: Rocket,
  title: "Startups",
  challenge: "Early-stage ventures seeking strong technical foundations, clean site architecture and realistic keyword priorities right from initial launch."
}, {
  icon: Users,
  title: "In-house marketing teams",
  challenge: "Internal marketing managers needing senior SEO input, audits or strategic oversight without hiring full-time, working alongside your developers and writers."
}, {
  icon: Globe2,
  title: "International businesses",
  challenge: "English-speaking organisations targeting multiple territories that need structured multi-regional setups and accurate international search targeting."
}];
export default function WhoIWorkWith() {
  return <section id="who-i-work-with" aria-labelledby="who-i-work-with-heading" className="bg-muted/40 text-foreground py-20 lg:py-28 border-b border-border/40">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14 lg:mb-16">
          <p className="text-xs sm:text-sm font-semibold uppercase tracking-wider text-primary mb-3">
            Client Focus
          </p>
          <h2 id="who-i-work-with-heading" className="font-serif text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-foreground leading-tight">
            Who I Work With
          </h2>
          <p className="mt-4 text-base sm:text-lg text-muted-foreground leading-relaxed">
            As an independent UK freelance SEO consultant, I deliver remote consulting shaped around your company’s size, resources and commercial goals.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {clientGroups.map(group => {
          const Icon = group.icon;
          return <div key={group.title} className="col-span-1">
                <Card className="h-full bg-card border-border shadow-xs hover:border-primary/40 transition-colors">
                  <CardHeader className="pb-3">
                    <div className="size-11 rounded-lg bg-primary/10 text-primary flex items-center justify-center mb-4">
                      <Icon className="size-5" />
                    </div>
                    <CardTitle className="font-serif text-lg sm:text-xl font-bold text-card-foreground">
                      {group.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                      {group.challenge}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}

          <div className="col-span-1 md:col-span-2 lg:col-span-3">
            <Card className="bg-card border-border shadow-xs p-6 sm:p-7">
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <div className="size-11 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0">
                  <MonitorCheck className="size-5" />
                </div>
                <div>
                  <h3 className="font-serif text-lg font-bold text-card-foreground mb-1">
                    Fully Remote Delivery
                  </h3>
                  <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                    Whether you are based in the UK or overseas, all consultancy is delivered remotely through scheduled video calls, regular email updates and clear shared documents.
                  </p>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}